// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"a734b7f29ac32fa5306a","655":"92bb87301be6c5d357da"}[chunkId] + ".js";
};